// extracted by mini-css-extract-plugin
export var logo = "welcome-screen-module--logo--HYP5-";
export var welcomeScreen = "welcome-screen-module--welcomeScreen--FQ9K7";
export var welcomeScreenMessage = "welcome-screen-module--welcomeScreenMessage--NUBEg";